"use strict";Object.defineProperty(exports, "__esModule", {value: true});


var _XDATOVDXcjs = require('../__chunks/XDATOVDX.cjs');
require('../__chunks/JLMLKTUB.cjs');
require('../__chunks/PTOCUU2D.cjs');
require('../__chunks/3BSDKDKD.cjs');
require('../__chunks/XMDZRF6Y.cjs');



exports.Heading = _XDATOVDXcjs.Heading; exports.useHeading = _XDATOVDXcjs.useHeading;
